import { Injectable, Inject } from '@angular/core';
import { CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { DOCUMENT } from '@angular/platform-browser';
import { ConfigService } from './config.service';
import { OktaService } from './okta.service';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private oktaService: OktaService,
        private authService: AuthService,
        private router: Router,
        private configService: ConfigService,
        @Inject(DOCUMENT) private document: Document
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let url: string = state.url;
        return this.checkLogin(url);
    }

    checkLogin(url: string): boolean {
        if (this.authService.isLoggedIn()) { return true; }
        // Store the attempted URL for redirecting

        // Navigate to the login page with extras
        this.router.navigate(['/login']);
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/auth-guard.service.ts